import { gql } from '@apollo/client'

export const STORE_ACTION_RANKING_FRAGMENT = gql`
  fragment StoreActionRanking on StoreActionRanking {
    store {
      id
      location {
        name
      }
    }
    rank
    tasksCompletionPercentage
  }
`
